import styled from 'styled-components';
import { COLOR } from '../../../styles/variables';
import { hexOpacity } from '../../../utils/helper/styling';

export const StyledButton = styled.a`
    display: flex;
    align-items: center;
    width: fit-content;
    padding: 0.5rem 1rem;
    color: ${COLOR.br24.white};
    line-height: 1.5;
    background: ${COLOR.br24.blue};
    border: 0;
    border-radius: 4px;
    appearance: none;
    cursor: pointer;
    text-align: center;
    gap: 0.5em;

    :hover {
        background: ${hexOpacity(COLOR.br24.blue, 0.75)};
    }

    :active {
        background: ${COLOR.br24.blue};
    }
`;
